// Keep operation columns on one line without changing ordinary text columns.
// Width is measured only after table updates; no polling or mutation observers.
const actionClass = 'admin-actions-column'

export function installTableActions (ElementUI) {
  const tableMixin = {
    mounted () {
      // Slot changes can update the table body without updating ElTable itself.
      this._actionWidthBody = this.$children.find(child => child.$options.name === 'ElTableBody' && !child.fixed)
      if (this._actionWidthBody) this._actionWidthBody.$on('hook:updated', this.scheduleActionWidth)
      this.scheduleActionWidth()
    },
    updated () { this.scheduleActionWidth() },
    beforeDestroy () {
      if (this._actionWidthBody) this._actionWidthBody.$off('hook:updated', this.scheduleActionWidth)
      if (this._actionWidthFrame) cancelAnimationFrame(this._actionWidthFrame)
    },
    methods: {
      scheduleActionWidth () {
        if (this._actionWidthFrame || this._isDestroyed || this._isBeingDestroyed) return
        if (!this.store.states.columns.some(column => (column.className || '').split(/\s+/).includes(actionClass))) return
        this._actionWidthFrame = requestAnimationFrame(() => {
          this._actionWidthFrame = null
          if (this._isDestroyed || this._isBeingDestroyed || !this.$el.offsetWidth) return
          // A row can re-render for a permission/status change independently of its body.
          if (this._actionWidthBody) this._actionWidthBody.$children.forEach(row => {
            if (row.$options.name !== 'ElTableRow' || row._actionWidthOwner === this) return
            row._actionWidthOwner = this
            row.$on('hook:updated', this.scheduleActionWidth)
          })
          let changed = false
          this.store.states.columns.forEach(column => {
            if (!(column.className || '').split(/\s+/).includes(actionClass)) return
            const cells = this.$el.querySelectorAll('.el-table__body-wrapper td.' + column.id + ' > .cell')
            let required = 0
            cells.forEach(cell => {
              // max-content cells include padding, but not the table cell border.
              required = Math.max(required, Math.ceil(cell.getBoundingClientRect().width) + 1)
            })
            if (required > Math.max(column.width || 0, column.realWidth || 0, column.minWidth || 0)) {
              column.width = required
              changed = true
            }
          })
          if (changed) this.doLayout()
        })
      }
    }
  }
  const columnMixin = {
    mounted () {
      if ((this.label || '').replace(/\s/g, '') !== '操作') return
      const column = this.columnConfig
      column.className = ((column.className || '') + ' ' + actionClass).trim()
      // Preserve each page's original fixed-column setting.
      this.$nextTick(() => {
        if (!this.owner._isDestroyed) this.owner.scheduleActionWidth()
      })
    }
  }
  ElementUI.Table.mixins = (ElementUI.Table.mixins || []).concat(tableMixin)
  ElementUI.TableColumn.mixins = (ElementUI.TableColumn.mixins || []).concat(columnMixin)
}



// WEBPACK FOOTER //
// ./src/utils/tableActions.js